module.exports = __webpack_public_path__ + "static/media/300c-front-wishbone.cd69c10e.jpg";